import { useSelector, shallowEqual } from 'react-redux';
import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';
import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';
import { useMeterType } from './useMeterType';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';

export const useEvTariffInformation = () => {
  const { isDSJourney } = usePartner();
  const { isEvException } = useMeterType();
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const isAgentSalesJourney = useIsLoginEnabledJourney({
    exclude: [PARTNERS.NONDOMESTIC_TRANSFER]
  });

  const isAllowedJourney = isAgentSalesJourney || isDSJourney;

  return {
    showEvTariffInformation:
      !isEvException && electricVehicle && isAllowedJourney
  };
};
